import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/bb74bfb/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js";
import MdxLayout from '../../src/components/mdx-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = MdxLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`To help slow the spread of the COVID-19 pandemic, the staff of national
statistical organizations around the world are being required to work from home,
creating challenges in managing workflow solutions and, in many cases, accessing
tools and support from external partners.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      